import React, { createContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser]       = useState(null);
    const [token, setToken]     = useState(null);
    const [loading, setLoading] = useState(true);

    // ── On mount: restore from localStorage ──────────────────
    useEffect(() => {
        const savedToken = localStorage.getItem('ista_token');
        const savedUser  = localStorage.getItem('ista_user');
        if (savedToken && savedUser) {
            setToken(savedToken);
            setUser(JSON.parse(savedUser));
        }
        setLoading(false);
    }, []);

    // ── Role → home path mapping ─────────────────────────────
    const getHomePath = (role) => {
        const paths = {
            admin:    '/admin/offres',
            director: '/director/offres',
            trainer:  '/trainer/candidatures',
        };
        return paths[role] || '/';
    };

    // ── Login ────────────────────────────────────────────────
    const login = async (email, password) => {
        const { data } = await authAPI.login({ email, password });
        const { user: u, token: t } = data;

        localStorage.setItem('ista_token', t);
        localStorage.setItem('ista_user', JSON.stringify(u));
        setToken(t);
        setUser(u);

        return u;
    };

    // ── Logout ───────────────────────────────────────────────
    const logout = async () => {
        try { await authAPI.logout(); } catch (_) { /* ignore */ }
        localStorage.removeItem('ista_token');
        localStorage.removeItem('ista_user');
        setToken(null);
        setUser(null);
    };

    // ── Helper: get user's ISTA info ─────────────────────────
    const getUserIsta = () => user?.ista || null;

    return (
        <AuthContext.Provider value={{ user, setUser, token, loading, login, logout, getHomePath, getUserIsta }}>
            {children}
        </AuthContext.Provider>
    );
}
